import { render, staticRenderFns } from "./DoctorView.vue?vue&type=template&id=18806e1e"
import script from "./DoctorView.vue?vue&type=script&lang=js"
export * from "./DoctorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports